module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-d2cbb9824d17417f36af6ad3687cf3cf.png";